import { faPlus } from "@fortawesome/free-solid-svg-icons";
import styles from "./+layout.style.module.scss";
import menuStyles from "../../tags/app-menu/app-menu.style.module.scss";
import type { HeadingList } from "../../types";
export interface Input {
  content: Marko.Body;
}

// A stable id so the layout's skip link has something to target; the styling
// hook moved to a class to free it up.
article id="main-content" tabindex="-1" class=styles.article
  ${input.content}
  hr
  section id=styles.contributors
    h2#contributors
      a href="#contributors" -- Contributors
    p --
      Helpful? You can thank these awesome people! You can also edit this doc if
      you see any issues or want to improve it.
    await|contributors|=$global.contributors
      ul
        for|contributor| of=contributors
          li
            a href=contributor.url
              img src=contributor.photo alt=""
              -- ${contributor.username}
        li
          a href=(
            `https://github.com/marko-js/website/blob/main/docs/${$global.url.pathname.slice(
              $global.url.pathname.indexOf("/docs/") + "/docs/".length,
            )}.md`
          )
            div
              fa-icon=faPlus
            -- You?

define/TocTree|input: { headings: HeadingList }|
  for|heading| of=input.headings
    li
      let/current=false
      script --
        const element = document.getElementById(heading.id);
        if (element) {
          const observer = new IntersectionObserver(
            ([entry]) => {
              current = entry.isIntersecting;
            },
            {
              rootMargin: "-20% 0px -20% 0px",
            },
          );
          observer.observe(element);
          $signal.onabort = () => observer.disconnect();
        }
      a href=`#${heading.id}` aria-current=current && "step" -- ${heading.title}
      if=(heading.children.length)
        ul
          TocTree headings=heading.children

id/tocLabelId
div#page-menu class=menuStyles.menu
  nav aria-labelledby=tocLabelId class=menuStyles.nav id=styles.pageNav
    ul
      li
        strong id=tocLabelId -- On this Page
      TocTree headings=($global.meta.headings ?? [])
